// @ts-nocheck
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import DatePickerWithPopper from 'components/atoms/DatePickerWithPopper/DatePickerWithPopper';
import MuiTimepicker from 'components/__v2__/MuiTimepicker/Timepicker';
import { FIELD_TYPES } from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constant';

const datePickerStyle = {
  '& .datepicker': {
    position: 'relative',
  },
};

const DateTimePreview = ({
  field,
  tableId,
  tableType,
  rowIndex,
  colIndex,
  updateAnswer,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  let selectedDateTime = null;

  if (field.answer) {
    if (field.type === FIELD_TYPES.DATE) {
      selectedDateTime = new Date(field.answer);
    } else if (field.type === FIELD_TYPES.TIME) {
      const [hours, minutes] = field.answer.split(':');
      selectedDateTime = new Date();
      selectedDateTime.setHours(hours, minutes);
    } else if (field.type === FIELD_TYPES.DATETIMELLOCAL) {
      selectedDateTime = new Date(field.answer);
    }
  }

  const handleChange = (dateTime) => {
    if (!dateTime) return;
    let answer;

    if (field.type === FIELD_TYPES.DATE) {
      const adjustedDate = new Date(
        dateTime.getTime() - dateTime.getTimezoneOffset() * 60000,
      );
      const [date] = adjustedDate.toISOString().split('T');
      answer = date;
    } else if (field.type === FIELD_TYPES.TIME) {
      const hours = dateTime.getHours().toString().padStart(2, '0');
      const minutes = dateTime.getMinutes().toString().padStart(2, '0');
      answer = `${hours}:${minutes}`;
    } else if (field.type === FIELD_TYPES.DATETIMELLOCAL) {
      const adjustedDate = new Date(
        dateTime.getTime() - dateTime.getTimezoneOffset() * 60000,
      );
      const formattedDate = adjustedDate.toISOString().split('T')[0];
      const hours = dateTime.getHours().toString().padStart(2, '0');
      const minutes = dateTime.getMinutes().toString().padStart(2, '0');
      answer = `${formattedDate}T${hours}:${minutes}`;
    }

    updateAnswer(tableId, rowIndex, colIndex, answer);
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(tableId, answer, tableType, '', {
        rowIndex,
        colIndex,
        tableElementType: field?.type,
      });
    }
  };

  return (
    <Stack
      flexDirection="column"
      justifyContent="space-between"
      spacing={1}
      sx={datePickerStyle}
    >
      {(field.type === FIELD_TYPES.DATETIMELLOCAL ||
        field.type === FIELD_TYPES.DATE) && (
        <Box>
          <DatePickerWithPopper
            startDate={selectedDateTime}
            dateChangeHandler={handleChange}
            disabled={shouldBeReadOnly}
          />
        </Box>
      )}
      {(field.type === FIELD_TYPES.DATETIMELLOCAL ||
        field.type === FIELD_TYPES.TIME) && (
        <Box>
          <MuiTimepicker
            value={selectedDateTime}
            onChange={handleChange}
            placeholder="Choose your time"
            disabled={shouldBeReadOnly}
          />
        </Box>
      )}
    </Stack>
  );
};

export default DateTimePreview;
